import { TransactionTypeEnum } from '../modules/shared/models/transaction-type.enum';
import { BaseListFilter } from './base-list-filter.model';

export class TransactionsListFilter extends BaseListFilter {
  type?: TransactionTypeEnum[];
  dealIds?: number[];
  withPromisedPaymentsFailed?: boolean;
}
